<div  fxLayout="column" class="layout-padd " [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div *ngIf="!devices ||(devices && devices.length==0)" class="layout-padd  full-w " fxLayoutAlign="start center"
        fxLayoutGap="20px">

        <div>
            <img src="assets/img/user/emptyuser.png"  class="h-10">
        </div>
        <div fxLayoutAlign="center center">
            <span class="mat-title ">{{"borne.user_dialo.title"|translate}}</span>
        </div>

    </div>

    <div *ngIf="!devices ||(devices && devices.length==0)" fxLayout="column" fxLayoutAlign="start center"
        class="layout-padd scrolled heightouch ">


        <form fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="stretch" class="full-w" [formGroup]="passForm"
            #formDirective="ngForm" (ngSubmit)="submitPass(formDirective)">

            <div class="borneTxt" >
                <p>{{"borne.user_dialo.text"|translate}} <span *ngIf="!searchbornedevice">{{"borne.user_dialo.textStop"|translate}}</span> </p>
            </div>

            <div class="form-field-endorder">

                <mat-form-field appearance="outline" fxFlex>

                    <mat-label>{{"code" | translate}}</mat-label>

                    <input type="text" matInput placeholder="{{'code' | translate}}" formControlName="user"
                        (focus)="onfocus()" (mouseout)="onfocus()" (mouseover)="onfocus()" (ngModelChange)="onfocus()">

                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="passForm.controls['user'].errors?.required">
                        <span class="mat-caption">{{"required" | translate}}</span>
                    </mat-error>
                    <mat-error fxLayout fxLayoutAlign="start center" *ngIf="passForm.controls['user'].errors?.pattern">
                        <span class="mat-caption">{{"format invalide (chiffres)" | translate}}</span>
                    </mat-error>
                    <mat-error fxLayout fxLayoutAlign="start center"
                        *ngIf="passForm.controls['user'].errors?.minlength">
                        <span class="mat-caption">{{"(min 4)" | translate}}</span>
                    </mat-error>



                </mat-form-field>

            </div>
            <div fxLayout fxLayoutAlign="start center" *ngIf="$error">
                <span class=" warn-ico">{{"borne.user_dialo.textError"|translate}}</span>
            </div>



            <div class="layout-padd positionBottomtouch" fxLayoutGap="10px" fxflex>


                <button type="submit" mat-stroked-button class="primary rounded-button" fxFlex angulartics2On="click"
                    angularticsAction="submitUserCodeTouchterminal" angularticsCategory="payBridgeCancel">
                    <span class="mat-title">{{"validate-button"|translate}}</span>
                </button>

                <button mat-stroked-button class="dark-ico rounded-button" fxFlex (click)="closeDial()">
                    <span class="mat-title">{{ "cancel_button"|translate}}</span>
                </button>



            </div>
        </form>









    </div>




    <div *ngIf="admin&&searchbornedevice&& (devices && devices.length>0)" class="layout-padd  full-w "
        fxLayoutAlign="start center" fxLayoutGap="20px">

        <div>
            <img src="assets/img/refonte-logo/payment.png"  class="h-10">

        </div>
        <div fxLayoutAlign="center center">
            <span class="mat-title ">{{"borne.choiceDevice"|translate}}  </span>
        </div>

    </div>




    <div *ngIf="admin&&searchbornedevice&& (devices && devices.length>0)" fxLayout="column" fxLayoutGap="30px"
        fxLayoutAlign="start center" class="layout-padd scrolled heightouch ">



        <mat-form-field>

            <mat-label>{{'borne.devices'|translate}}</mat-label>


            <mat-select placeholder="{{'borne.devices'|translate}}" [(ngModel)]="currdevice">

                <mat-option (click)="currdevice=null" style="background-color: rgb(11, 83, 164);color: white;"> <span>-
                        {{'borne.none'|translate}}-</span>
                </mat-option>
                <mat-option *ngFor="let item of devices" [value]="item.id">

                    <div fxLayout="column">
                        <div>
                            {{'borne.terminal'|translate}}    {{item.PREFIX}}
                        </div>

                        <div style="font-size: 10px;">({{item.model}} - {{item.id}})</div>

                    </div>

                </mat-option>


            </mat-select>



        </mat-form-field>

        <!-- Checkbox -->
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-checkbox [disabled]="!currdevice" class="great-ico" class="text-center" angulartics2On="click"
                angularticsAction="acceptTerms" angularticsCategory="order"
                [(ngModel)]="currdevicePrintAuto"></mat-checkbox>
            <div class="text-center">
                <span class="mat-caption">{{"borne.printAuto"|translate}} </span>
            </div>
        </div>





        <div class="layout-padd positionBottomtouch" fxLayoutGap="10px" fxflex>


            <button mat-stroked-button class="primary rounded-button" fxFlex (click)="setdevice()"
                angulartics2On="click" angularticsAction="setdevice" angularticsCategory="setpayBridgedevice">
                <span class="mat-title">{{"validate-button"|translate}}</span>
            </button>

            <button mat-stroked-button class="dark-ico rounded-button" fxFlex (click)="closeDial()">
                <span class="mat-title">{{ "cancel_button"|translate}}</span>
            </button>



        </div>
    </div>



</div>
